import React from "react";
import { SectionCta } from "../SectionCta";
import { CREATOR_PHOTO_URL } from "../../data/site";
export function CreatorSection() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-134" data-mp="2bd3xq6j0h5w4">
      <div className="mx-auto max-w-5xl" data-id="element-135" data-mp="2pdent7chygg8">
        <div className="grid gap-8 md:grid-cols-[0.9fr_1.1fr] md:items-start md:gap-12" data-id="element-136" data-mp="2pcdaew80dhvc">
          <div className="overflow-hidden rounded-3xl bg-canvas" data-id="element-137" data-mp="2kel95blh4jeh">
            <img src={CREATOR_PHOTO_URL} alt="Rachel Bennett, Critical Care Nursing Educator, in an ICU" className="aspect-square w-full object-cover" loading="lazy" data-id="element-138" data-mp="1wnpnyxbiwmg7" />
          </div>

          <div data-id="element-139" data-mp="26gdejabwtu6h">
            <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-140" data-mp="21nkdoxjkb5zo">About the creator</p>
            <h2 className="mt-3 text-[1.9rem] font-extrabold leading-tight tracking-tight text-navy sm:text-5xl" data-id="element-141" data-mp="1dxq2ekew5phj">Hi, I’m Rachel Bennett.</h2>
            <p className="mt-2 text-lg font-semibold text-muted" data-id="element-142" data-mp="18y3khxo4bl2e">Critical Care Nursing Educator</p>

            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-143" data-mp="2t3pz3y6ua1pm">
              <p data-id="element-144" data-mp="2y218k7t82a7b">Hemodynamic monitoring involves a wide range of interconnected concepts.</p>
              <p data-id="element-145" data-mp="32v3txsnuidcf">
                From blood pressure and cardiac output to vascular resistance, ventricular performance, and tissue perfusion, understanding
                these subjects requires more than memorizing individual definitions.
              </p>
              <p data-id="element-146" data-mp="2f4gfeojfcpgw">
                One of the challenges of studying hemodynamics is that related information is often spread across different textbooks,
                lecture notes, and reference materials.
              </p>
              <p className="font-semibold text-navy" data-id="element-147" data-mp="2o5enbhwzhh4r">
                The Hemodynamic Monitoring Blueprint™ brings these subjects together in a structured educational collection.
              </p>
              <p data-id="element-148" data-mp="3e4fhjpm6kgb">
                The purpose isn’t to replace clinical training. It’s to provide a structured educational reference you can return to as you
                continue learning.
              </p>
              <p data-id="element-149" data-mp="1vffbb5hdymx1">I hope the Blueprint™ becomes a useful part of your professional study routine.</p>
            </div>
            <p className="mt-6 text-2xl font-extrabold italic text-navy" data-id="element-150" data-mp="29fq1s7es9zho">— Rachel Bennett</p>
          </div>
        </div>

        <SectionCta label="Start studying with Rachel’s Blueprint™" data-id="element-151" data-mp="24f2enwtoe2sq" />
      </div>
    </section>;
}